import React from 'react';
import {
  Autocomplete,
  TextField,
  Box,
  Typography,
} from '@mui/material';

interface OriginCriterionSelectProps {
  value: string;
  onChange: (value: string) => void;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

const originCriteria = [
  {
    code: 'A',
    description: 'Wholly obtained or produced in the territory of one or more of the Parties',
  },
  {
    code: 'B',
    description: 'Produced entirely in the territory of one or more of the Parties using non-originating materials',
  },
  {
    code: 'C',
    description: 'Produced in the territory of one or more of the Parties exclusively from originating materials',
  },
  {
    code: 'D',
    description: 'Produced in the territory of one or more of the Parties using non-originating materials with regional value content',
  },
  {
    code: 'E',
    description: 'Other applicable criterion',
  },
];

const OriginCriterionSelect: React.FC<OriginCriterionSelectProps> = ({
  value,
  onChange,
  error = false,
  helperText,
  required = false,
  disabled = false,
  size = 'medium',
}) => {
  return (
    <Autocomplete
      freeSolo
      options={originCriteria}
      getOptionLabel={(option) => {
        if (typeof option === 'string') return option;
        return option.code;
      }}
      value={originCriteria.find(c => c.code === value?.toUpperCase()) || value}
      onChange={(_, newValue) => {
        if (typeof newValue === 'string') {
          onChange(newValue.toUpperCase());
        } else {
          onChange(newValue?.code || '');
        }
      }}
      onInputChange={(_, newInputValue) => {
        onChange(newInputValue.toUpperCase());
      }}
      renderOption={(props, option) => (
        <Box component="li" {...props} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
          <Typography variant="body2" fontWeight={600}>
            {option.code}
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ whiteSpace: 'normal' }}>
            {option.description}
          </Typography>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Criterion"
          required={required}
          error={error}
          helperText={helperText}
          size={size}
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
              borderRadius: '8px',
            },
          }}
        />
      )}
      disabled={disabled}
    />
  );
};

export default OriginCriterionSelect;